import { createFileRoute, notFound } from "@tanstack/react-router";
import authStyles from "../styles/auth.css?url";
import { PasswordRecovery } from "../components/auth/password-recovery";
import { recoveryTarget } from "../lib/auth-route";
import { useShell } from "../lib/document-route";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { keepSearch } from "../lib/search";
import { isPlatformShell } from "../platform/shell";
import { loadRecovery } from "../server/auth";
import { useAuthSearch } from "../lib/published-auth";

/** Choosing a new password from a reset link; never indexed. */
export const Route = createFileRoute("/reset-password")({
  validateSearch: keepSearch,
  // A creator site's page only: Drate's own host has no account here.
  loader: async ({ parentMatchPromise }) => {
    if (isPlatformShell((await parentMatchPromise).loaderData)) throw notFound();
    await loadRecovery({ data: "/reset-password" });
  },
  head: ({ matches }) => {
    const shell = shellFrom(matches);
    if (!shell) return {};
    return withStylesheet(
      creatorPageHead(shell, {
        pathname: "/reset-password",
        title: `Choose a new password | ${shell.creator.name}`,
        description: "Your content, your community, your corner of the internet.",
        noindex: true,
      }),
      authStyles,
    );
  },
  component: ResetPassword,
});

function ResetPassword() {
  const shell = useShell();
  const { query, ready } = useAuthSearch(Route.useSearch(), !!shell.publication);
  return (
    <PasswordRecovery
      name={shell.creator.name}
      reset
      token={!ready && shell.publication ? "prepared-request-token" : query.get("token") || ""}
      target={recoveryTarget(query.get("returnTo") || "/account")}
      error={query.get("error") || undefined}
    />
  );
}
